import React, { useState } from 'react';
import "./style.css"
import { Collapse } from 'react-collapse'
import { AiOutlineSearch } from 'react-icons/ai'
import { NavLink } from 'react-router-dom'
import { IoIosArrowDown } from "react-icons/io";
import SideNav from './../../../components/SideNav';
import ConsultasPendentes from './../../../components/Display_Organizador/Listar_Consultas/Pendentes';
import ConsultasEncaminhadas from './../../../components/Display_Organizador/Listar_Consultas/Encaminhadas';

export default function Tela_Consultas() {
    let [search, setSearch] = useState(false);
    let [options, setOptions] = useState(false);
    let [options2, setOptions2] = useState(false);


    return (
        <>
            <SideNav />
            <div id="top-Consulta">

            <div id="backbutton">
            <NavLink id="voltar-a" to="/"> <button id="voltar">Voltar</button></NavLink>
        </div>

            <div id="searchbutton3">
                <Collapse isOpened={search}>
                    <input id="Consulta"
                        type="text"
                        placeholder="pesquisa..."
                    />
                </Collapse>
                <div id="searchBar">
                    <AiOutlineSearch
                        size={'5vh'}
                        onClick={() => setSearch(!search)}
                        id="Icon-Search-Consulta"
                    />
                </div>
            </div>
            </div>

            <div id="main-Consulta">
                    <p id="Consulta">Consultas Pendentes</p>
                    <hr id="divider-Consulta" />
                    <div id="arrow-Consulta">
                        <IoIosArrowDown
                            onClick={() =>
                                setOptions(!options)
                            }
                            size={"6vh"}
                            id="IconDown-Consulta"
                        />
                    </div>
                    <Collapse isOpened={options}>
                        <div id="collapsed-Consulta">
                        <ConsultasPendentes />
                         </div>
                    </Collapse>     
 
                    <p id="Consulta">Consultas Encaminhadas</p>
                    <hr id="divider-Consulta" />
                    <div id="arrow-Consulta2">
                        <IoIosArrowDown
                            onClick={() =>
                                setOptions2(!options2)
                            }
                            size={"6vh"}
                            id="IconDown-Consulta"
                        />
                    </div>
                    <Collapse isOpened={options2}>
                        <div id="collapsed-Consulta2">
                            <ConsultasEncaminhadas />
                        </div>
                    </Collapse>
            </div>
        </>
    );
}